<template>
  <div v-if="itemsRendered">        
    <component
      v-bind:is="popularAccountsComponent"
      v-bind:ads="adsInstance"
      v-bind:bank="bank"
      v-bind:popularAccounts="popularAccounts"
    ></component>
  </div>
  <div class="popularAccountsBox" v-else>
    <div class="row">
      <div class="col-12 col-sm colWithoutLeftPadding">
        <div class="firstLine da-skeleton-loader"></div>
        <div class="secondLine da-skeleton-loader"></div>
        <div class="firstLine da-skeleton-loader"></div>
        <div class="secondLine da-skeleton-loader"></div>
        <div class="firstLine da-skeleton-loader"></div>
        <div class="secondLine da-skeleton-loader"></div>
        <div class="secondLine da-skeleton-loader"></div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue, { defineComponent } from "vue";
import popularAccountsForAdvertiser from "./advertisers/popularAccounts.vue";
import popularAccountsForNonAdvertiser from "./non-advertisers/popularAccounts.vue";
import defaultAdsOfPA from "./defaultAds/defaultAdsOfPA.vue";
import apiClient from "../../services/apiClient";
import analytics from "../../services/analytics";
import Enumerable from "linq";

declare interface bankObject {
  FinId: number;
}

export default defineComponent({
  components: {
    popularAccountsForAdvertiser,
    popularAccountsForNonAdvertiser,
    defaultAdsOfPA,
  },
  data: function () {
    return {
      adsInstance: [] as AdPlacement[],
      bank: Object as any,
      popularAccounts: [],
      itemsRendered: false,
      popularAccountsComponent: {}     
    };
  },
  created() {
    this.bank = (<any>window).depositAccounts.popularAccountsWidget.Bank;
    this.popularAccounts = (<any>(
      window
    )).depositAccounts.popularAccountsWidget.PopularAccounts;
  },
  mounted() {    
    apiClient
      .getAdPlacementsInZone("da-bp-pa", this.bank.FinId)
      .then((adsData) => {
        if (!(adsData && adsData.length)) {
          return;
        }
        this.adsInstance = Enumerable.from(adsData)
          .orderByDescending((x) => x.account.apy)
          .toArray();
        analytics.trackAdImpressions("da-bp-pa", adsData);
      })
      .finally(() => {
        this.popularAccountsComponent = this.assignComponent();
        //make visible on next tick, after rendering
        this.$nextTick(() => {
          this.itemsRendered = true;
        });
      });
  },
  methods: {
    // Assigning dynamic component based on data
    assignComponent() {
      // Got the ads for bank
      if (this.adsInstance.length) {
        return popularAccountsForAdvertiser;
      }
      // There isn't ads, but got popular accounts
      else if (this.popularAccounts && this.popularAccounts.length) {
        return {};
      }
      // No Ads, No popular accounts. Show default ads
      else {
        if (this.isBigDevice()) {
          return defaultAdsOfPA;
        }
      }
      return {};
    },
    isBigDevice() {
      // $(window).width() not the same as media query https://stackoverflow.com/a/22708436
      // $(window).width() calculating scrollbar width as well. It affects desktop browsers with < 767 width only
      // http://caniuse.com/#feat=matchmedia (Not supporting IE9)
      return window.matchMedia("(min-width: 768px)").matches;
    },
  },
});
</script>
<style lang="scss" scoped>
 @keyframes loading {
            100% {
                transform: translateX(100%);
            }
        }

        .da-skeleton-loader {
            background: rgba(221, 221, 221, 0.4);
            overflow: hidden;
            position: relative;
        }

            .da-skeleton-loader::after {
                background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
                animation: loading 1.5s infinite;
                content: "";
                height: 100%;
                left: 0;
                position: absolute;
                right: 0;
                top: 0;
                transform: translateX(-100%);
                z-index: 1;
            }

         .firstLine {
            min-width: 140px;
            min-height: 25px;
            margin-bottom: 8px;
            margin-top:10px;
            border-radius: 3px;
        }
          .secondLine {
            min-width: 140px;
            min-height: 15px;
            margin-bottom: 8px;
            margin-top:10px;
            border-radius: 3px;
        }
</style>
